export const BROKERS_STORAGE_KEYS = {
  CORE: 'mt6_brokers_core'
} as const;
